module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic.1aa0a986.woff2";